import { sprintf } from 'sprintf-js';
const _ = importLib('lodash');
const M = importLib('moment');
const Vuex = importLib('vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

export default {

    watch: {

    },

    computed: {
        ...Vuex.mapGetters([
            'comparedSilageHybrids',
            'comparedGrainHybrids',
            'hybridPages',
            'hybridType',
            'silageRegion',
            'grainRegion',
            'hybridMapping',
        ]),

        compareHybridRegion() {
            if (this.hybridType == 'silage') {
                return this.silageRegion;
            }
            if (this.hybridType == 'grain') {
                return this.grainRegion;
            }
        },

        comparedHybridIds: {
            get() {
                let availableHybrids = _.chain(this.hybridMapping)
                    .filter(mapping => {
                        if (!this.compareHybridRegion) {
                            return mapping.type == this.hybridType;
                        }

                        return mapping.type == this.hybridType
                            && mapping.hybrid_region_id == this.compareHybridRegion;
                    })
                    .map('hybrid_id')
                    .value();

                if (this.hybridType == 'silage') {
                    return _.filter(this.comparedSilageHybrids, (hybridId) => {
                        return _.includes(availableHybrids, hybridId)
                    });
                } else {
                    return _.filter(this.comparedGrainHybrids, (hybridId) => {
                        return _.includes(availableHybrids, hybridId)
                    });
                }
            },
            set(newVal) {
                if (this.hybridType == 'silage') {
                    this.setComparedSilageHybrids(newVal);
                } else {
                    this.setComparedGrainHybrids(newVal);
                }
            },
        },

        // get today's correct date based on user timezone
        todaysDate() {
            let today = new Date();
                today.setMinutes(today.getMinutes() - today.getTimezoneOffset());

            return today.toISOString().split('T')[0];
        },

        _() {
            return _;
        },

        api() {
            return api;
        },
    },

    methods: {
        ...Vuex.mapMutations([
            'setComparedSilageHybrids',
            'setComparedGrainHybrids',
            'setHybridType',
            'setSilageRegion',
            'setGrainRegion',
        ]),

        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },

        isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },

        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + parseInt(days) );
            return result;
        },

        getHarvestDays(plantDate, harvestDate) {
            if(plantDate && harvestDate){
                let startDate = new Date(plantDate);
                let endDate = new Date(harvestDate);

                const diffInMs = Math.abs(endDate - startDate);

                let days = diffInMs / (1000 * 60 * 60 * 24);

                return Math.round(days);
            }

            return 0;
        },

        addCompareHybrid(hybrid) {
            let items = this.comparedHybridIds;
            let hybrids = _.union([hybrid], items);

            this.comparedHybridIds = hybrids;
        },

        removeCompareHybrid(hybrid) {
            let items = this.comparedHybridIds;
            let hybrids = _.pull(items, hybrid);

            this.comparedHybridIds = hybrids;
        },

        getTraitDisplayValue(value) {
            return value ?? '-';
        }

    }
}
